import { render, staticRenderFns } from "./Signatory.vue?vue&type=template&id=db6e1a6e&scoped=true&"
import script from "./Signatory.vue?vue&type=script&lang=js&"
export * from "./Signatory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6e1a6e",
  null
  
)

export default component.exports